import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./ContadoresDestacados.css";

interface BaseValue {
  id: number;
  contador: number;
}

const baseValues: BaseValue[] = [
  { id: 1, contador: 100000 },
  { id: 2, contador: 150 },
  { id: 3, contador: 60 },
  { id: 4, contador: 50 },
  { id: 5, contador: 80 },
  { id: 6, contador: 5 },
];

export default function ContadoresDestacados() {
  const { t } = useTranslation();
  const [contadores, setContadores] = useState<BaseValue[]>(
    baseValues.map((c) => ({
      ...c,
      contador: 0,
    })),
  );
  const contadoresRef = useRef<HTMLDivElement>(null);
  const animandoRef = useRef(false);

  function animarContadores() {
    animandoRef.current = true;
    const duracionAnimacion = 2000;
    const inicio = performance.now();

    function animate(time: number) {
      const progreso = Math.min((time - inicio) / duracionAnimacion, 1);
      const nuevosValores = baseValues.map((caja) => ({
        ...caja,
        contador: Math.floor(caja.contador * progreso),
      }));
      setContadores(nuevosValores);

      if (progreso < 1) {
        requestAnimationFrame(animate);
      } else {
        animandoRef.current = false;
      }
    }

    requestAnimationFrame(animate);
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !animandoRef.current) {
          setContadores(
            baseValues.map((c) => ({
              ...c,
              contador: 0,
            })),
          );
          animarContadores();
        }
      },
      { threshold: 0.5 },
    );

    const current = contadoresRef.current;
    if (current) observer.observe(current);

    return () => {
      if (current) observer.unobserve(current);
    };
  }, [t]);

  return (
    <section
      ref={contadoresRef}
      className="contadores-section"
      style={{
        backgroundImage: "url('/particula.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      } as React.CSSProperties}
    >
      <h2 className="contadores-titulo">{t("contadores.title")}</h2>
      <div className="contadores-grid">
        {contadores.map((caja) => (
          <div className="contador-caja" key={caja.id}>
            <div className="contador-numero">
              {caja.contador.toLocaleString("es-AR")}
            </div>
            <div className="contador-label">
              {t(`contadores.items.${caja.id - 1}`)}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
